<div class="title">{{ title }}</div>
<ng-content></ng-content>
